/* np-khub-banner.js — Klaviyo Customer Hub 内に「新サイズ登場」バナーを差し込む（Newport / dermalogica.jp）
 * Hubの編集画面にバナー部品がないため、np-khub-ja.js と同じ方式（Hub描画後にDOMを触る）で入れる。
 * .kl-hub-drawer の中だけを触る。要素が見つからなければ何もしない。
 * 表示期間：日本時間 2026-10-20 00:00:00 〜 2026-10-27 23:59:59
 * テスト：URLに ?np_hub_banner_test=1 を付けると、そのタブ（sessionStorage）だけ期間外でも表示。=0 で解除。
 */
(function () {
  if (window.__npKhubBanner) return;
  window.__npKhubBanner = true;

  var START = new Date('2026-10-20T00:00:00+09:00').getTime();
  var END = new Date('2026-10-27T23:59:59+09:00').getTime();
  var HREF = 'https://dermalogica.jp/blogs/news/new-sizes-202610?utm_source=customer_hub&utm_medium=banner&utm_campaign=20261020_newsizes';
  var ATTR = 'data-np-hub-banner';
  var TEST_KEY = 'np_hub_banner_test';

  function testMode() {
    var v = null;
    try {
      var m = location.search.match(/[?&]np_hub_banner_test=([^&]*)/);
      if (m) {
        v = m[1];
        if (v === '1') sessionStorage.setItem(TEST_KEY, '1');
        else sessionStorage.removeItem(TEST_KEY);
      }
    } catch (e) {}
    if (v !== null) return v === '1';
    try { return sessionStorage.getItem(TEST_KEY) === '1'; } catch (e) { return false; }
  }
  var TEST = testMode();

  function inPeriod() {
    if (TEST) return true;
    var now = Date.now();
    return now >= START && now <= END;
  }

  if (!inPeriod() && Date.now() > END) return; // 期間終了後は監視もしない

  var CSS =
    '.np-hub-banner{display:block;box-sizing:border-box;margin:8px 16px 16px;padding:18px 20px;' +
    'background:#F4F5F6;border:1px solid #E3E5E7;border-radius:4px;color:#5B6770;' +
    'font-family:inherit;text-decoration:none;text-align:left;line-height:1.6;}' +
    '.np-hub-banner:hover,.np-hub-banner:focus{color:#5B6770;text-decoration:none;border-color:#949CA2;}' +
    '.np-hub-banner:focus-visible{outline:2px solid #949CA2;outline-offset:2px;}' +
    '.np-hub-banner__eyebrow{display:block;margin:0 0 6px;font-size:11px;letter-spacing:.12em;' +
    'text-transform:lowercase;color:#949CA2;font-weight:400;}' +
    '.np-hub-banner__title{display:block;margin:0 0 6px;font-size:15px;font-weight:500;letter-spacing:.04em;color:#5B6770;}' +
    '.np-hub-banner__text{display:block;margin:0;font-size:12px;letter-spacing:.02em;color:#5B6770;}';

  function ensureStyle() {
    if (document.getElementById('np-hub-banner-style')) return;
    var s = document.createElement('style');
    s.id = 'np-hub-banner-style';
    s.textContent = CSS;
    (document.head || document.documentElement).appendChild(s);
  }

  function span(cls, text) {
    var e = document.createElement('span');
    e.className = cls;
    e.textContent = text;
    return e;
  }

  function build() {
    var a = document.createElement('a');
    a.className = 'np-hub-banner';
    a.href = HREF;
    a.setAttribute(ATTR, '1');
    a.appendChild(span('np-hub-banner__eyebrow', 'new sizes'));
    a.appendChild(span('np-hub-banner__title', 'レフィル、はじまりました。'));
    a.appendChild(span('np-hub-banner__text', 'レフィル3品とＡＯ ハイドラミスト 250mLが新登場。ご購入でトライアルをプレゼント（10/27まで）。'));
    return a;
  }

  function findCloseButton(drawer) {
    var btns = drawer.querySelectorAll('button, [role="button"]');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      var label = ((b.getAttribute('aria-label') || '') + ' ' + (b.getAttribute('title') || '')).toLowerCase();
      if (/close|閉じ/.test(label)) return b;
    }
    return null;
  }

  // 閉じるボタンを含む「ヘッダー」= ドロワー直下までのうち、文字量が少ない最も外側の祖先
  function findHeader(drawer, closeBtn) {
    var header = closeBtn;
    var el = closeBtn;
    while (el.parentElement && el.parentElement !== drawer) {
      var p = el.parentElement;
      if ((p.textContent || '').trim().length > 60) break;
      header = p;
      el = p;
    }
    return header;
  }

  function run() {
    if (!inPeriod()) return;
    var drawer = document.querySelector('.kl-hub-drawer');
    if (!drawer) return;
    if (drawer.querySelector('[' + ATTR + ']')) return; // 二重挿入しない
    var closeBtn = findCloseButton(drawer);
    if (!closeBtn) return;
    var header = findHeader(drawer, closeBtn);
    if (!header || header === drawer || !header.parentElement) return;
    var next = header.nextElementSibling;
    if (!next) return; // 中身が未描画
    ensureStyle();
    header.parentElement.insertBefore(build(), next);
  }

  var timer = null;
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () {
      timer = null;
      try { run(); } catch (e) {}
    }, 80);
  }
  try {
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
  schedule();
})();
